export default __webpack_public_path__ + "static/media/j.c567fc86.mp4";